var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('create-evaluation-popup', {
    attrs: {
      "is-opened": _vm.show_add_evaluation || false,
      "date-debut": _vm.form.date_debut_evaluation,
      "date-fin": _vm.form.date_fin_evaluation
    },
    on: {
      "close": function ($event) {
        _vm.show_add_evaluation = false;
      },
      "changeDateDebut": function (newValue) {
        if (_vm.form.date_fin_evaluation == '' || _vm.$verifyDates({
          debut: newValue,
          fin: _vm.form.date_fin_evaluation
        })) {
          _vm.form.date_debut_evaluation = newValue;
        } else {
          _vm.badDates();
          _vm.form.date_debut_evaluation = '';
        }
      },
      "changeDateFin": function (newValue) {
        if (_vm.form.date_debut_evaluation == '' || _vm.$verifyDates({
          debut: _vm.form.date_debut_evaluation,
          fin: newValue
        })) {
          _vm.form.date_fin_evaluation = newValue;
        } else {
          _vm.badDates();
          _vm.form.date_fin_evaluation = '';
        }
      },
      "createEvaluation": _vm.create_evaluation
    }
  }), _vm._v(" "), _c('close-evaluation-popup', {
    attrs: {
      "is-opened": _vm.confirmCloseEvaluation > -1,
      "is-step-one": _vm.confirmCloseEvaluation == 0,
      "is-step-two": _vm.confirmCloseEvaluation == 1,
      "today": _vm.today
    },
    on: {
      "close": function ($event) {
        _vm.confirmCloseEvaluation = -1;
      },
      "closeEval": _vm.close_eval
    }
  }), _vm._v(" "), _c('choose-job-desc-popup', {
    ref: "addJobPopup",
    attrs: {
      "is-displayed": _vm.isNewSheetPopupDisplayed || false,
      "job-not-found": _vm.jobNotFound || false,
      "libelle-page": _vm.infosPage.libelle_page,
      "deleted-desc": _vm.deletedDesc,
      "num-job": _vm.job,
      "type-structure": _vm.constants.TYPE_OF
    },
    on: {
      "close": function ($event) {
        return _vm.toggleAddJobPopup(false);
      },
      "hasResult": function (hasResultFound) {
        _vm.noSearchResult = hasResultFound;
      },
      "selectJobDesc": function (selectedJob) {
        _vm.addJob(selectedJob);
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.isPopupConfirmRemovePosteDisplayed > -1
    },
    on: {
      "close": function ($event) {
        _vm.isPopupConfirmRemovePosteDisplayed = -1;
      }
    }
  }, [_vm.isPopupConfirmRemovePosteDisplayed === 0 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-20 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n          Retirer le référentiel de formation " + _vm._s(_vm.jobForm.nom_du_poste) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Êtes-vous sûr de vouloir retirer le référentiel\n          " + _vm._s(_vm.jobForm.nom_du_poste) + " du poste " + _vm._s(_vm.job) + ", concernant le\n          bénéficiaire " + _vm._s(_vm.infosPass.name) + " ?\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Cette action sera définitive et irrévocable.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Vous pouvez continuer à consulter les historiques des évaluations.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CONFIRMER",
      "uppercase": true,
      "icon": "trash-2",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.removeCurrentPoste();
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.isPopupConfirmRemovePosteDisplayed === 1 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-6 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-10 text-pink-600"
  }, [_vm._v("Référentiel de formation retiré")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          La référentiel de formation " + _vm._s(_vm.job) + " a bien été retiré\n        ")]), _vm._v(" "), _vm.listEvaluations.length > 0 ? _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Vous pouvez consulter les historiques des évaluations liés à ce\n          poste\n        ")]) : _vm._e(), _vm._v(" "), _c('illustration', {
    staticClass: "w-full my-10",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "my-15 2xl:my-20 mx-1/4"
  }, [_vm._v("\n    " + _vm._s(_vm.getLibelle({
    infosPage: _vm.infosPage
  })) + "\n  ")]), _vm._v(" "), _vm.form.date_debut_evaluation == '' || _vm.form.date_fin_evaluation == '' || _vm.form.id_ref == 0 || _vm.form.template == {} ? _c('div', {
    staticClass: "m-5 lg:m-15 mb-0"
  }, [_vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) && _vm.role !== _vm.constants.ROLE_BENEFICIAIRE ? _c('div', [_c('div', {
    staticClass: "flex justify-center w-full"
  }, [(_vm.jobs[_vm.job - 1] === undefined ? _vm.jobs[_vm.job - 1] === undefined : _vm.jobs[_vm.job - 1].id) && _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) && !_vm.jobNotFound ? _c('span', [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER UNE ÉVALUATION",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        _vm.show_add_evaluation = true;
      }
    }
  })], 1) : _vm.role !== _vm.constants.ROLE_BENEFICIAIRE && (_vm.jobs[_vm.job - 1] || _vm.jobs[_vm.job - 1].id || _vm.jobNotFound) ? _c('span', [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "CHOISIR UN RÉFÉRENTIEL DE FORMATION",
      "icon": "file-text",
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        _vm.loadJobs();
        _vm.toggleAddJobPopup(true);
      }
    }
  })], 1) : _c('div', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Vous n'avez pas sélectionné de référentiel de formation.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "evaluation"
    }
  })], 1), _vm._v(" "), _vm.role !== _vm.constants.ROLE_BENEFICIAIRE && _vm.jobForm.nom_du_poste ? _c('div', {
    staticClass: "flex justify-center w-full mt-15"
  }, [_c('div', {
    staticClass: "w-max"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "text-color-hover": "hover:text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-hover": "hover:bg-pink-600",
      "bg-color-square": "bg-indigo-600",
      "bg-color-square-hover": "group-hover:bg-pink-600",
      "icon-color": "text-white",
      "icon-color-hover": "hover:text-white",
      "libelle": 'Retirer le référentiel de formation' + (!_vm.$isMobile() ? ' ”' + _vm.jobForm.nom_du_poste + '” du poste ' + _vm.job : ''),
      "icon": "trash-2",
      "type-shadow": "shadow-indigo",
      "type-shadow-hover": "hover:shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.displayConfirmRemovePoste();
      }
    }
  })], 1)]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n        Il n’y a pas d’évaluation en cours\n        "), _vm.listEvaluations.length > 0 ? _c('span', [_vm._v("\n          , vous pouvez consulter\n          "), _c('br'), _vm._v("\n          vos évaluations précédentes dans l’historique ci-dessous\n        ")]) : _vm._e(), _vm._v("\n        .\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])]) : _c('div', [_vm.compareCarto ? _c('PopupCompareCarto', {
    attrs: {
      "compare-carto": _vm.compareCarto,
      "carto-to-compare": _vm.cartoToCompare,
      "history-to-display": _vm.historyToDisplay,
      "competences-cles": {},
      "history-competences-cles": [],
      "competences-informatique": {},
      "history-competences-informatique": [],
      "competences-linguistique": {},
      "history-competences-linguistique": [],
      "competences-socio-pro": {},
      "history-competences-socio-pro": {},
      "competences-pro": {},
      "history-competences-pro": {},
      "competences-sco": _vm.competencesSco,
      "history-competences-sco": Object.fromEntries(Object.entries(_vm.historyCompetencesSco).filter(function (_ref) {
        var pageName = _ref[0],
          hist = _ref[1];
        return hist.template_name == _vm.competencesSco.template_name && pageName == _vm.infosPage.name_page;
      }))
    },
    on: {
      "close": _vm.closeCompare,
      "changeCompare": function (index) {
        _vm.changeCompare(index);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.role !== _vm.constants.ROLE_BENEFICIAIRE && _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) ? _c('div', {
    staticClass: "w-full mb-15 2xl:mb-20 flex justify-center"
  }, [_c('list-action-buttons', {
    attrs: {
      "today": _vm.today,
      "libelle-template": _vm.form.name_job,
      "can-compare-cartography": _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE) && _vm.listEvaluations.length > 0,
      "can-compare-but-not-enough-evaluation": _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE) && _vm.listEvaluations.length === 0
    },
    on: {
      "confirmCloseEvaluation": function ($event) {
        _vm.confirmCloseEvaluation = 0;
      },
      "displayCompareCarto": function ($event) {
        return _vm.displayCompareCarto('compsco/' + _vm.infosPage.name_page);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.jobType === 'ref_formation' ? _c('div', [_vm.jobForm.modules && _vm.jobForm.modules.length > 0 ? _c('div', {
    staticClass: "text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center h-16 2xl:h-24"
  }, [_c('div', {
    staticClass: "col-start-3 lg:col-start-2 col-span-6 md:col-span-7"
  }, [_vm._v("\n          Domaines\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4"
  }, [_vm._v("Temps consacré")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.jobForm.modules, function (mod, num) {
    return _c('div', {
      key: num,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.itemDisplayed == num
      },
      attrs: {
        "id": 'module' + num
      },
      on: {
        "click": function ($event) {
          return _vm.displayItem(num);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-2 md:col-span-1 text-pink-600 justify-self-center flex flex-col justify-around"
    }, [_c('icon', {
      staticClass: "transform transition-transform ease-in-out duration-300",
      class: {
        'rotate-90': _vm.itemDisplayed == num
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 md:col-span-7 text-base font-normal"
    }, [_c('span', [_vm._v(_vm._s(mod.module_name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-4 text-base font-normal"
    }, [_vm.form.items.modules[num].general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== '' || _vm.form.items.modules[num].general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== undefined || _vm.form.items.modules[num].general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== null || _vm.form.items.modules[num].general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value !== [] ? _c('span', [_vm._v("\n              " + _vm._s(_vm.form.items.modules[num].general.filter(function (gen) {
      return gen.name.includes('Temps');
    })[0].value) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_vm.itemDisplayed === num ? _c('div', {
      staticClass: "bg-white my-5 lg:my-10 px-10"
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-4 lg:gap-y-10 mb-15"
    }, _vm._l(_vm.form.template.filter(function (temp) {
      return !['Critères d\'évaluation', 'Critères'].includes(temp.libelle);
    }), function (gen, index) {
      return _c('div', {
        key: index,
        staticClass: "col-span-full md:col-span-6"
      }, [_c('input-select', {
        attrs: {
          "disabled": _vm.role === _vm.constants.ROLE_BENEFICIAIRE,
          "name": gen.libelle.replace('\'', ''),
          "necessary": true,
          "libelle": gen.libelle,
          "value": _vm.form.items.modules[num].general[index].value,
          "datas": gen.criterions
        },
        on: {
          "input": function (newValue) {
            _vm.$set(_vm.form.items.modules[num].general[index], 'value', newValue);
          }
        }
      })], 1);
    }), 0), _vm._v(" "), _c('module-category', {
      attrs: {
        "datas": mod.module_competences,
        "form": _vm.form.items.modules[num].module_competences,
        "list-criterions": _vm.listCriterions,
        "name": "module_competences",
        "is-necessary": true,
        "id-pass": _vm.infosPass.id_pass,
        "id-user": _vm.user.id,
        "hidden-fields": _vm.hiddenFields,
        "latest-eval": ((((_vm.latestEval || {}).items || {}).modules || [])[num] || {}).module_competences || [],
        "preview-mode": false
      },
      on: {
        "setAutoEvaluation": function (numCompetence, numCritere, newValue) {
          _vm.$set(_vm.form.items.modules[num].module_competences[numCompetence].criterions[numCritere], 'auto', newValue);
        },
        "setReferentEvaluation": function (numCompetence, numCritere, newValue) {
          _vm.$set(_vm.form.items.modules[num].module_competences[numCompetence].criterions[numCritere], 'value', newValue);
        },
        "setComment": function (numCompetence, numCritere, newValue) {
          _vm.$set(_vm.form.items.modules[num].module_competences[numCompetence].criterions[numCritere], 'comment', newValue);
        },
        "hideField": function (field) {
          _vm.hiddenFields[field] = !_vm.hiddenFields[field];
        }
      }
    }), _vm._v(" "), _c('module-category', {
      attrs: {
        "datas": mod.module_competences_transversales,
        "form": _vm.form.items.modules[num].module_competences_transversales,
        "list-criterions": _vm.listCriterions,
        "name": "module_competences_transversales",
        "is-necessary": true,
        "id-pass": parseInt(_vm.infosPass.id_pass),
        "id-user": parseInt(_vm.user.id),
        "hidden-fields": _vm.hiddenFields,
        "latest-eval": ((((_vm.latestEval || {}).items || {}).modules || [])[num] || {}).module_competences_transversales || [],
        "preview-mode": false
      },
      on: {
        "setAutoEvaluation": function (numCompetence, numCritere, newValue) {
          _vm.$set(_vm.form.items.modules[num].module_competences_transversales[numCompetence].criterions[numCritere], 'auto', newValue);
        },
        "setReferentEvaluation": function (numCompetence, numCritere, newValue) {
          _vm.$set(_vm.form.items.modules[num].module_competences_transversales[numCompetence].criterions[numCritere], 'value', newValue);
        },
        "setComment": function (numCompetence, numCritere, newValue) {
          _vm.$set(_vm.form.items.modules[num].module_competences_transversales[numCompetence].criterions[numCritere], 'comment', newValue);
        },
        "hideField": function (field) {
          _vm.hiddenFields[field] = !_vm.hiddenFields[field];
        }
      }
    })], 1) : _vm._e()])], 1);
  })], 2) : _vm._e(), _vm._v(" "), _vm.jobType === 'rome' ? _c('evaluation-rome', {
    attrs: {
      "form": _vm.form,
      "id-pass": _vm.infosPass.id_pass,
      "id-user": _vm.user.id
    },
    on: {
      "changeValue": function (infos) {
        _vm.form.items[infos.typeCompetence][infos.typeSavoir][infos.value.key][infos.evaluatorType] = infos.value.value;
      }
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }